"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
const react_1 = __importStar(require("react"));
const downshift_1 = __importDefault(require("downshift"));
const assets_1 = require("~/assets");
const types_1 = require("~/store/types");
const react_i18next_1 = require("react-i18next");
const Option_1 = __importDefault(require("./Option"));
const FormDropdown_scss_1 = __importDefault(require("./FormDropdown.scss"));
function FormDropdown(_a) {
    var { inputKey, state: { error, value }, onInput, onError, placeholder, options, required = false, headlineComponent, disabled = false } = _a, props = __rest(_a, ["inputKey", "state", "onInput", "onError", "placeholder", "options", "required", "headlineComponent", "disabled"]);
    const { t } = (0, react_i18next_1.useTranslation)('messages');
    const [focused, setFocused] = (0, react_1.useState)(false);
    const [validate, setValidate] = (0, react_1.useState)(false);
    const clearElementRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if ((value === null || value === void 0 ? void 0 : value.value) === undefined && clearElementRef.current) {
            clearElementRef.current.click();
        }
    }, [value]);
    (0, react_1.useEffect)(() => {
        if (!focused && validate && required && !value) {
            onError(inputKey, types_1.INPUT_ERRORS.required);
            return;
        }
        onError(inputKey, types_1.INPUT_ERRORS.none);
    }, [focused, validate, required, value]);
    const changeHandler = (selection) => {
        var _a;
        onInput(inputKey, (_a = selection === null || selection === void 0 ? void 0 : selection.key) !== null && _a !== void 0 ? _a : null);
    };
    const focusHandler = () => {
        setFocused(true);
        // eslint-disable-next-line no-unused-expressions
        !validate && setValidate(true);
    };
    const blurHandler = () => setFocused(false);
    const highlighter = (option, key) => {
        if (!key) {
            return option;
        }
        const index = option.toLocaleLowerCase().indexOf(key.toLocaleLowerCase());
        return index >= 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
            option.substring(0, index),
            react_1.default.createElement("b", null, option.substring(index, index + key.length)),
            option.substring(index + key.length))) : (option);
    };
    return (react_1.default.createElement(downshift_1.default, { initialSelectedItem: value !== null && value !== void 0 ? value : undefined, onChange: changeHandler, itemToString: (option) => (option ? option.value : ''), selectedItem: value }, ({ inputValue, selectedItem, isOpen, getToggleButtonProps, getInputProps, getItemProps, getMenuProps, clearSelection, highlightedIndex, toggleMenu, }) => (react_1.default.createElement("div", null,
        react_1.default.createElement("div", Object.assign({ className: `${FormDropdown_scss_1.default.container} ${error ? FormDropdown_scss_1.default.error : ''}`, "data-disabled": disabled }, props),
            react_1.default.createElement("input", Object.assign({ "data-testid": inputKey }, getInputProps({ placeholder }), { onFocus: () => {
                    toggleMenu({ isOpen: true });
                    focusHandler();
                }, onBlur: blurHandler, disabled: disabled })),
            !disabled && (react_1.default.createElement("div", { className: FormDropdown_scss_1.default.controls },
                selectedItem ? (react_1.default.createElement("img", { src: assets_1.svgSystemClose, onClick: () => clearSelection(), ref: clearElementRef, alt: "" })) : null,
                react_1.default.createElement("img", Object.assign({}, getToggleButtonProps(), { src: isOpen ? assets_1.svgSystemChevronUp : assets_1.svgSystemChevronDown, alt: "" })),
                error ? (react_1.default.createElement("div", { className: FormDropdown_scss_1.default.errorIcon },
                    react_1.default.createElement("img", { src: assets_1.svgSystemError, alt: "" }))) : null))),
        isOpen && !disabled ? (react_1.default.createElement("div", Object.assign({}, getMenuProps(), { className: FormDropdown_scss_1.default.menu }),
            headlineComponent && react_1.default.createElement("div", { className: FormDropdown_scss_1.default.headlineComponent }, headlineComponent),
            options &&
                options.some((option) => !inputValue || option.value.toLocaleLowerCase().includes(inputValue.toLocaleLowerCase())) ? (options
                .filter((option) => !inputValue || option.value.toLocaleLowerCase().includes(inputValue.toLocaleLowerCase()))
                .map((option, index) => (react_1.default.createElement(Option_1.default, Object.assign({ key: option.key }, getItemProps({
                item: option,
                index,
            }), { isHighlighted: highlightedIndex === index }), highlighter(option.value, inputValue))))) : (react_1.default.createElement("div", { className: FormDropdown_scss_1.default.empty }, inputValue ? (react_1.default.createElement(react_1.default.Fragment, null,
                t('dropdown.no-results-by'),
                " ",
                react_1.default.createElement("b", null, inputValue))) : (t('dropdown.empty')))))) : null,
        error ? react_1.default.createElement("div", { className: FormDropdown_scss_1.default.error }, error) : null))));
}
FormDropdown.defaultProps = {
    placeholder: undefined,
    required: undefined,
    headlineComponent: undefined,
    disabled: undefined,
};
exports.default = FormDropdown;
